import React, { useState } from 'react';

interface ApiErrorProps {
  error: Error;
  onRetry: () => void;
  onEnableMockMode: () => void;
}

const ApiError: React.FC<ApiErrorProps> = ({ error, onRetry, onEnableMockMode }) => {
  const [expanded, setExpanded] = useState(false);

  return (
    <div className="p-6 bg-red-50 dark:bg-red-900/20 border border-red-300 dark:border-red-800 rounded-xl shadow-sm">
      <div className="flex items-start justify-between">
        <div className="flex items-center">
          <div className="w-10 h-10 flex-shrink-0 bg-red-100 dark:bg-red-800 rounded-full flex items-center justify-center text-red-500 dark:text-red-200">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6">
              <path strokeLinecap="round" strokeLinejoin="round" d="M12 9v3.75m9-.75a9 9 0 11-18 0 9 9 0 0118 0zm-9 3.75h.008v.008H12v-.008z" />
            </svg>
          </div>
          <div className="ml-4">
            <h3 className="text-lg font-medium text-red-800 dark:text-red-200">API Connection Error</h3>
            <p className="mt-1 text-sm text-red-700 dark:text-red-300">
              Unable to connect to the backend service
            </p>
          </div>
        </div>
      </div>

      <div className="mt-4">
        <p className="text-sm text-red-700 dark:text-red-300">
          {error.message || "The application couldn't establish a connection to the backend API."}
        </p>
        
        {expanded && (
          <pre className="mt-2 p-3 bg-red-100 dark:bg-red-900/30 rounded text-xs font-mono text-red-800 dark:text-red-200 overflow-x-auto">
            {error.stack}
          </pre>
        )}
        
        <div className="mt-4 flex flex-wrap gap-3">
          <button
            onClick={onRetry}
            className="inline-flex items-center px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-red-600 hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500"
          >
            <svg xmlns="http://www.w3.org/2000/svg" className="-ml-1 mr-2 h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
            </svg>
            Retry Connection
          </button>
          {/* <button
            onClick={onEnableMockMode}
            className="inline-flex items-center px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-red-700 bg-red-100 hover:bg-red-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500"
          >
            <svg xmlns="http://www.w3.org/2000/svg" className="-ml-1 mr-2 h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9.75 17L9 20l-1 1h8l-1-1-.75-3M3 13h18M5 17h14a2 2 0 002-2V5a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
            </svg>
            Enable Mock Mode
          </button> */}
          <button
            onClick={() => setExpanded(!expanded)}
            className="inline-flex items-center px-4 py-2 border border-red-300 dark:border-red-700 rounded-md text-sm font-medium text-red-700 dark:text-red-300 bg-transparent hover:bg-red-50 dark:hover:bg-red-900/30 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500"
          >
            {expanded ? 'Hide' : 'Show'} Details
          </button>
        </div>
      </div>
    </div>
  );
};

export default ApiError;
